// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"657":"40ca8d27","787":"155200c1"}[chunkId] + ".chunk.js";
};